<template>
  <b-navbar class="header d-print-none app-header text-right">
    <b-collapse id="nav-collapse" is-nav>
      <b-nav class="mr-auto d-md-down-none">
        <b-nav-item-dropdown id="v-step-2" class="settingsDropdown" no-caret left>
          <template slot="button-content">
            <i class="fa-duotone fa-gears px-2 h4"></i>
          </template>
          <b-dropdown-item @click="$router.push({ name: 'MyProfile' })">پروفایل من <i class="fa-duotone fa-address-card float-right"></i> </b-dropdown-item>
          <b-dropdown-divider />

          <b-dropdown-item v-show="myTicketsShow" v-if="$session.has('CustomerInfo')" @click="$router.push({ name: 'CustomerTicket' })">تیکت های من <i class="fad fa-user-headset float-right"></i></b-dropdown-item>
          <b-dropdown-item v-show="myTicketsShow" v-else @click="$router.push({ name: 'Tickets', params: { formHeader: true } })">تیکت های من <i class="fad fa-user-headset float-right"></i></b-dropdown-item>
          <b-dropdown-item v-show="myWorksShow" v-if="!$session.has('CustomerInfo')" @click="$router.push({ name: 'Task' })">کـارهـای من <i class="fad fa-siren-on float-right"></i></b-dropdown-item>
          <b-dropdown-item v-show="alarmShow" v-if="!$session.has('CustomerInfo')" @click="$router.push({ name: 'Alarm' })"> یــادآور مـن <i class="fa-duotone fa-alarm-clock float-right"></i></b-dropdown-item>
          <b-dropdown-item v-show="workTipsShow" v-if="!$session.has('CustomerInfo')" @click="$router.push({ name: 'WorkTips' })">نکات کاری<i class="fa-solid fa-briefcase float-right"></i></b-dropdown-item>
          <b-dropdown-item @click="$router.push({ name: 'lastLogin' })">آخرین ورود من <i class="fa-duotone fa-sign-in float-right"></i></b-dropdown-item>
          <b-dropdown-divider />
          <b-dropdown-item @click="logout"> خـروج <i class="fa-duotone fa-arrow-right-from-bracket float-right"></i> </b-dropdown-item>
        </b-nav-item-dropdown>

        <b-nav-item-dropdown v-if="$session.get('CustomerInfo') == undefined" class="notificationsMenu mr-2 mx-3" menu-class="notificationsWrapper py-0 animate__animated animate__animated-fast animate__fadeIn" right>
          <template slot="button-content">
            <span class="avatar rounded-circle thumb-sm float-right mr-2 d-md-down-none">
              <img class="rounded-circle" src="/img/pic/userNew.jpg" alt="..." />
            </span>
            <span class="px-2 d-md-down-none" v-if="$store.state.renderProfile">{{ this.$session.get('UserInfo').namFam }}</span>
            <!-- <b-badge variant="inverse" pill class="animate__animated animate__bounceIn" style="padding: 6px 9px">{{ $store.state.TaskCount }}</b-badge> -->
            <i class="fas fa-chevron-down px-md-2" />
          </template>
          <Notifications :TaskData="listTask"></Notifications>
        </b-nav-item-dropdown>

      </b-nav>
      <b-nav class="mr-auto d-md-none" v-if="!MenuOpen()">
        <b-nav-item-dropdown id="v-step-2" class="settingsDropdown" no-caret left>
          <template slot="button-content">
            <i class="fa-duotone fa-gears px-2"></i>
          </template>
          <b-dropdown-item @click="$router.push({ name: 'MyProfile' })">پروفایل من <i class="fa-duotone fa-address-card float-right"></i> </b-dropdown-item>
          <b-dropdown-divider />

          <b-dropdown-item v-show="myTicketsShow" v-if="$session.has('CustomerInfo')" @click="$router.push({ name: 'CustomerTicket' })">تیکت های من <i class="fad fa-user-headset float-right"></i></b-dropdown-item>
          <b-dropdown-item v-show="myTicketsShow" v-else @click="$router.push({ name: 'Tickets', params: { formHeader: true } })">تیکت های من <i class="fad fa-user-headset float-right"></i></b-dropdown-item>
          <b-dropdown-item v-show="myWorksShow" v-if="!$session.has('CustomerInfo')" @click="$router.push({ name: 'Task' })">کـارهـای من <i class="fad fa-siren-on float-right"></i></b-dropdown-item>
          <b-dropdown-item v-show="alarmShow" v-if="!$session.has('CustomerInfo')" @click="$router.push({ name: 'Alarm' })"> یــادآور مـن <i class="fa-duotone fa-alarm-clock float-right"></i></b-dropdown-item>
          <b-dropdown-item v-show="workTipsShow" v-if="!$session.has('CustomerInfo')" @click="$router.push({ name: 'WorkTips' })">نکات کاری<i class="fa-solid fa-briefcase float-right"></i></b-dropdown-item>
          <b-dropdown-divider />
          <b-dropdown-item @click="logout"> خـروج <i class="fa-duotone fa-arrow-right-from-bracket float-right"></i> </b-dropdown-item>
        </b-nav-item-dropdown>

        <b-nav-item-dropdown v-if="$session.get('CustomerInfo') == undefined" class="notificationsMenu mr-2 mx-3" menu-class="notificationsWrapper py-0 animate__animated animate__animated-fast animate__fadeIn" right>
          <template slot="button-content">
            <span class="avatar rounded-circle thumb-sm float-right mr-2 d-md-down-none">
              <img class="rounded-circle" src="/img/pic/userNew.jpg" alt="..." />
            </span>
            <span class="px-2 d-md-down-none" v-if="$store.state.renderProfile">{{ this.$session.get('UserInfo').namFam }}</span>
            <!-- <b-badge variant="inverse" pill class="animate__animated animate__bounceIn" style="padding: 6px 9px">{{ $store.state.TaskCount }}</b-badge> -->
            <i class="fas fa-chevron-down px-md-2" />
          </template>
          <Notifications :TaskData="listTask"></Notifications>
        </b-nav-item-dropdown>
      </b-nav>
      <b-nav class="d-sm-down-none mr-3">
        <advanced-search v-if="!$session.get('CustomerInfo')"></advanced-search>
      </b-nav>
      <b-nav class="float-right">
        <b-nav-item class="float-right">
          <sun-moon></sun-moon>
        </b-nav-item>
        <b-nav-item>
          <a class="px-2 d-md-down-none" href="#" @click="toggleSidebarMethod" id="barsTooltip"> <i class="fi flaticon-menu" /> </a>
          <a class="fs-lg d-lg-none" href="#" @click="toggleSidebarMethod"> <i class="fi flaticon-menu" /> </a>
        </b-nav-item>
      </b-nav>
    </b-collapse>
    <b-nav>
      <!-- </b-nav>
    <a class="navbarBrand d-md-none">
      <i class="fa fa-circle text-danger" />
      &nbsp;
      APP
      &nbsp;
      <i class="fa fa-circle text-primary" />
    </a>
    <b-nav> -->

      <!-- <b-nav-item class="d-md-down-none">
        <a href="#" class="px-2">
          <i class='fi flaticon-flip' />
        </a>
      </b-nav-item>
      <b-nav-item class="d-md-down-none">
        <a href="#" class="px-2">
          <i class='fi flaticon-close' />
        </a>
      </b-nav-item> -->
    </b-nav>
  </b-navbar>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Notifications from '@/components/Notifications/Notifications'
import SunMoon from '@/components/ThemeButton/SunMoon'
import AdvancedSearch from './AdvancedSearch.vue'
import SearchableCombo from '../Combo/SearchableCombo.vue'

export default {
  data() {
    return {
      tarixAz: null,
      tarixTa: this.$store.state.JalaliDate,
      DataAxios_GetdatRiz: { ArryfildValue: {} },
      TaskCount: 0,
      listTask: [],
      list: [],
      DataAxiosUpdate: {
        ArryfildValue: {},
        Method: 'put',
        Action: '',
        Token: this.$session.get('Token'),
        From: 'Body',
      },
      myTicketsShow:false,
      workTipsShow:false,
      myWorksShow:false,
      alarmShow:false,
    }
  },
  name: 'Header',
  components: { Notifications, SunMoon, AdvancedSearch, SearchableCombo },
  computed: {
    ...mapState('layout', ['sidebarClose', 'sidebarStatic']),
  },
  methods: {
    ...mapActions('layout', ['toggleSidebar', 'switchSidebar', 'changeSidebarActive', 'toggleSidebarclose']),
    switchSidebarMethod() {
      if (!this.sidebarClose) {
        this.switchSidebar(true)
        this.changeSidebarActive(null)
      } else {
        this.switchSidebar(false)
        const paths = this.$route.fullPath.split('/')
        paths.pop()
        this.changeSidebarActive(paths.join('/'))
      }
    },
    toggleSidebarMethod() {
      if (this.sidebarStatic) {
        this.toggleSidebar()
        this.changeSidebarActive(null)
      } else {
        this.toggleSidebar()
        const paths = this.$route.fullPath.split('/')
        paths.pop()
        this.changeSidebarActive(paths.join('/'))
      }
    },
    logout() {
      var DataAxiosLogOut = { Method: 'POST', Action: 'Authentication/LogOut', ArryfildValue: { Id: this.$session.get('UserInfo').tblUserId } }
      this.$PostData(DataAxiosLogOut)
        .then(() => {})
        .catch((e) => {
          console.warn(e)
        })
      window.localStorage.setItem('authenticated', false)
      this.$router.push('/')
      this.$session.clear()
      sessionStorage.removeItem('vuex')
    },
    SearchTask() {
      // this.isLoad=true
      this.$store.state.TaskRows = []
      this.listTask = []
      this.DataAxios_GetdatRiz.Action = 'Task/Index'
      this.DataAxios_GetdatRiz.ArryfildValue.tblUserId = this.$session.get('UserInfo').tblUserId
      this.DataAxios_GetdatRiz.ArryfildValue.TaskDateAz = this.tarixAz
      this.DataAxios_GetdatRiz.ArryfildValue.TaskDateTa = this.tarixTa
      this.DataAxios_GetdatRiz.ArryfildValue.Done = 'NoDone'
      this.DataAxios_GetdatRiz.Method = 'Post'
      ;(this.DataAxios_GetdatRiz.Token = this.$session.get('Token')),
        this.$PostData(this.DataAxios_GetdatRiz)
          .then((data) => {
            this.list = data
            let filter = data.filter((x) => x.Done == false)
            this.TaskCount = filter.length
            this.$store.state.TaskCount = this.TaskCount
          })
          .finally(() => {
            for (let index = 0; index < this.list.length; index++) {
              if (this.list[index].Done == false) {
                this.listTask.push(this.list[index])
              }
            }
          })
    },
    MenuOpen() {
      return this.sidebarStatic
    },
  },
  watch: {
    $route(to, from) {
      if (screen.width < 750) {
        this.toggleSidebarclose()
      }
    },
  },

  created() {
    // console.log(this.sidebarStatic)
    this.SearchTask()
    let menus = this.$session.get('Menu');
    this.myTicketsShow =  menus.find((x) => x.RouteName == 'otherMenus_myTickets').isMojaz
    this.myWorksShow =  menus.find((x) => x.RouteName == 'otherMenus_myWorks').isMojaz
    this.workTipsShow =  menus.find((x) => x.RouteName == 'otherMenus_workTips').isMojaz
    this.alarmShow =  menus.find((x) => x.RouteName == 'otherMenus_alarm').isMojaz
  },
}
</script>
<style src="./Header.scss" lang="scss"></style>
<style scoped>
i {
  color: var(--logo-color);
}
</style>
